import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Hero from "@/components/sections/Hero";
import Marquee from "@/components/sections/Marquee";
import Philosophy from "@/components/sections/Philosophy";
import Quotes from "@/components/sections/Quotes";
import Investment from "@/components/sections/Investment";
import Mentorship from "@/components/sections/Mentorship";
import Portfolio from "@/components/sections/Portfolio";
import ApplySteps from "@/components/sections/ApplySteps";
import ContactForm from "@/components/sections/ContactForm";

export default function HomePage() {
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const el = document.querySelector(location.hash);
      if (el) setTimeout(() => el.scrollIntoView({ behavior: "smooth" }), 150);
    }
  }, [location]);

  return (
    <main>
      <Hero />
      <Marquee />
      <Philosophy />
      <Quotes />
      <Investment />
      <Mentorship />
      <Portfolio />
      <ApplySteps />
      <ContactForm />
    </main>
  );
}
